import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Key } from 'readline';

interface Country {
    id: any;
    countryCode: any;
    countryName: any;
    flag?: string;
    isActive?: boolean;
    auditTrailId?: number | null;
}


interface CountryState {
    data: Country[];
    loading: boolean;
    error: string | null;
}


const PORT = import.meta.env.VITE_USERS_PORT;
const URL = import.meta.env.VITE_API_USERS_URL;

export const fetchCountry = createAsyncThunk<Country[], void, { rejectValue: string }>(
    'Country/fetchCountry',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: Country[] }>('/get_all_country', PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createCountry = createAsyncThunk<Country, any, { rejectValue: string }>(
    'Country/createCountry',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: Country }>('create_country', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateCountry = createAsyncThunk<Country, any, { rejectValue: string }>(
    'Country/updateCountry',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: Country }>('update_country', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const StateSlice = createSlice({
    name: 'Country',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as CountryState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCountry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCountry.fulfilled, (state, action: PayloadAction<Country[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCountry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createCountry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCountry.fulfilled, (state, action: PayloadAction<Country>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createCountry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateCountry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCountry.fulfilled, (state, action: PayloadAction<Country>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateCountry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default StateSlice.reducer;